import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { careerAndSeasonStatsNavSelector } from 'store/modules/statspro/career-and-season-stats/selectors/nav-selector';
import { useGetCompSeasonsQuery } from 'common/store/modules/api/afl-api';
import { useGetPlayerCareerSeasonStatsQuery } from 'common/store/modules/api/statsPro-api';
import { changeSeason } from 'common/store/modules/statspro/thunks/change-season';

export const SeasonNavItem = ({ isAFLW, playerId }) => {
    const dispatch = useDispatch();
    const nav = useSelector(careerAndSeasonStatsNavSelector);

    const { data: playerCareerData } = useGetPlayerCareerSeasonStatsQuery(
        { isAFLW: isAFLW, playerId: playerId },
        { skip: !playerId }
    );

    const { seasons } = useGetCompSeasonsQuery(
        { competitionId: nav.competition.id },
        {
            skip: !nav.competition.id && !playerCareerData,
            selectFromResult: ({ data = [] }) => ({
                seasons: [
                    { id: -1, name: getTranslation('label.stats.career') },
                    ...data.filter((item) =>
                        playerCareerData?.yearlySeasonStats.some(
                            (season) => season.seasonId === item.providerId
                        )
                    )
                ]
            })
        }
    );

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={seasons}
                itemToString={(season) => season?.name}
                icon="season-trophy"
                type="with-default"
                className="w-100"
                selectedItemToString={(item) => item?.name.split(' ')[0]}
                initialSelectedItem={
                    seasons.length && nav.season.id
                        ? seasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                activeItem={
                    seasons.length && nav.season.id
                        ? seasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                isReadyToRender={() => seasons?.length && nav.season.id}
                label={`${getTranslation(
                    'label.stats.career'
                )}/${getTranslation('label.stats.season')}`}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeSeason({
                            slice: 'career-and-season-stats',
                            season: selectedItem
                        })
                    );
                }}
            />
        </div>
    );
};

SeasonNavItem.propTypes = {
    isAFLW: PropTypes.bool,
    playerId: PropTypes.string
};
